import {AssetSupplier} from '../../domain/ppsr-service.domain';

export type SupplierType = 'Car Buying Service or Car Broker' |
  'Equipment manufacturer backed supplier' |
  'Equipment non-manufacturer backed supplier' |
  'Private sale, Vendor with ABN' |
  'Private sale, Individual';

export type PpsrAssetSupplierSearchValue = AssetSupplier | null;
